export const setAbsolutePath = () => {
  let path = getAbsolutePath();
  localStorage.setItem('path', path);
  localStorage.setItem('env', process.env.NODE_ENV);
}

export const getAbsolutePath = () => {
  if (process.env.VUE_APP_SERVER_BASE_URL) {
    return process.env.VUE_APP_SERVER_BASE_URL;
  }
  
  let loc = window.location;
  if (process.env.NODE_ENV === 'development') {
    return 'https://api-devstella.creatoros.ai';
  }
  return loc.href.substring(0, loc.href.length - ((loc.pathname + loc.search + loc.hash).length - 0));
}

export const getClientURL = () => {
  if (typeof window !== 'undefined' && window.location && window.location.origin) {
    return window.location.origin;
  }
  return process.env.VUE_APP_CLIENT_URL || process.env.VUE_APP_STELLA_URL || 'https://new.stella.so';
};
